/* eslint-disable no-param-reassign */
import produce from 'immer';
var deploymentInfoLoaded = produce(function (draft, action) {
  var _action$payload = action.payload,
    environment = _action$payload.environment,
    domainName = _action$payload.domainName;
  draft.environment = environment;
  draft.domainName = domainName;
});
export default deploymentInfoLoaded;